<template>
    <div class="training-courses-list container py-4">
        <div class="row searchbar-row mb-3">

            <!-- Search filter starts -->
            <div class="col-12 d-flex justify-content-center mb-4">
                <input v-model="search" @input="onSearch" type="text" class="form-control searchbar"
                    placeholder="Search courses..." />
            </div>
            <!-- Search filter ends -->

            <!-- Category filter starts -->
            <div class="col-4 col-md-6 mb-4 d-flex justify-content-center justify-content-md-end">

                <div>
                    <label for="category-select" class="form-label">Category</label>
                    <select id="category-select" v-model="selectedCategory" @change="onFilterChange"
                        class="form-control filter-select">
                        <option value="">All</option>
                        <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.title }}</option>
                    </select>
                </div>


            </div>
            <!-- Category filter ends -->

            <!-- Level filter starts -->
            <div class="col-4 col-md-6 mb-4 d-flex justify-content-center justify-content-md-start">

                <div>
                    <label for="level-select" class="form-label">Skill</label>
                    <select id="level-select" v-model="selectedLevel" @change="onFilterChange"
                        class="form-control filter-select">
                        <option value="">All</option>
                        <option v-for="level in levels" :key="level" :value="level">{{ level }}</option>
                    </select>
                </div>

            </div>
            <!-- Level filter ends -->

            <!-- premium video filters for small screens -->
            <!-- Show select on small screens -->
            <div class="col-4 col-md-6 mb-4 d-flex justify-content-center d-md-none">
                <div>
                    <label for="paid-filter-select" class="form-label">Video Type</label>
                    <select id="paid-filter-select" v-model="isPaidFilter" @change="onPaidFilterChange($event)"
                        class="form-control filter-select">
                        <option :value="null">All</option>
                        <option :value="false">Free</option>
                        <option :value="true">Paid</option>
                    </select>
                </div>
            </div>


        </div>

        <!-- Free or Paid filter starts -->
        <div class="row mb-4 d-none d-md-block">
            <div class="col-12 d-flex justify-content-center">
                <div class="btn-group paid-filter-group">
                    <button type="button" class="btn"
                        :class="isPaidFilter === null ? 'btn-primary' : 'btn-outline-primary'"
                        @click="setPaidFilter(null)">All</button>
                    <button type="button" class="btn"
                        :class="isPaidFilter === false ? 'btn-primary' : 'btn-outline-primary'"
                        @click="setPaidFilter(false)">Free</button>
                    <button type="button" class="btn"
                        :class="isPaidFilter === true ? 'btn-primary' : 'btn-outline-primary'"
                        @click="setPaidFilter(true)">Paid</button>
                </div>
            </div>
        </div>
        <!-- Free or Paid filter ends -->

        <!-- Page Content starts -->
        <div class="row mt-md-5 pt-md-5">
            <!-- Pre Loader -->
            <div v-if="loading" class="col-12 text-center py-5">
                <span>Loading...</span>
            </div>
            <!-- Fall back -->
            <div v-else-if="courses.length === 0" class="col-12 text-center py-5">
                <span>No courses found.</span>
            </div>
            <!-- Courses Listing cards -->
            <div v-else class="col-12">
                <div v-for="(pair, rowIdx) in cardPairs" :key="rowIdx" class="row">
                    <div
                        class="col-12 col-sm-12 col-md-6 col-lg-6 d-flex justify-content-center justify-content-md-end mb-4">
                        <Card v-if="pair[0]" :thumbnail="pair[0].thumbnailUrl || fallbackThumbnail"
                            :title="pair[0].title" :description="pair[0].description"
                            :category="pair[0].speciality.title" :level="pair[0].level"
                            :progressStatus="setProgressStatus(pair[0])" :isPaid="pair[0].isPaid"
                            :hasSubscription="subscription.exists" :isCourse="true" :isVideoLesson="false"
                            @click.native="onClickOfCourse(pair[0])" />
                    </div>
                    <div
                        class="col-12 col-sm-12 col-md-6 col-lg-6 d-flex justify-content-center justify-content-md-start mb-4">
                        <Card v-if="pair[1]" :thumbnail="pair[1].thumbnailUrl || fallbackThumbnail"
                            :title="pair[1].title" :description="pair[1].description"
                            :category="pair[1].speciality.title" :level="pair[1].level"
                            :progressStatus="setProgressStatus(pair[1])" :isPaid="pair[1].isPaid"
                            :hasSubscription="subscription.exists" :isCourse="true" :isVideoLesson="false"
                            @click.native="onClickOfCourse(pair[1])" />
                    </div>
                </div>
            </div>
        </div>
        <!-- Page content ends -->

        <!-- Pagination section -->
        <nav v-if="totalPages > 1" class="mt-4">
            <ul class="pagination justify-content-center">
                <li class="page-item" :class="{ disabled: page === 1 }">
                    <button class="page-link" @click="goToPage(page - 1)" :disabled="page === 1">Previous</button>
                </li>
                <li v-for="p in totalPages" :key="p" class="page-item" :class="{ active: p === page }">
                    <button class="page-link" @click="goToPage(p)">{{ p }}</button>
                </li>
                <li class="page-item" :class="{ disabled: page === totalPages }">
                    <button class="page-link" @click="goToPage(page + 1)" :disabled="page === totalPages">Next</button>
                </li>
            </ul>
        </nav>

        <!-- Components  Section-->

        <!-- <VideoPlayer v-if="showVideoModal && selectedVideo.videoUrl" v-bind="selectedVideo" :visible="showVideoModal"
            :modalMode="videoModalMode" @close="closeVideoPlayer" @update:modalMode="setVideoModalMode"
            @progress-updated="onProgressUpdated" /> -->

        <!-- Membership Dialog -->
        <div v-if="showMembershipDialog && !subscription.exists" class="modal fade show" tabindex="-1"
            style="display: block; background: rgba(0,0,0,0.5);">
            <MemberShipModal @get-membership="onGetMembership" @close="showMembershipDialog = false" />
        </div>
        <div v-if="showMembershipDialog" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
import Card from '@/components/TrainingCourses/Card.vue';
import MemberShipModal from '@/components/TrainingCourses/MemberShipModal.vue';
import axios from 'axios';
import { eventBus } from "@/main";

export default {
    name: 'TrainingCoursesList',
    components: { Card, MemberShipModal },
    data() {
        return {
            courses: [], // List of fetched courses
            loading: false, // Loading state for API calls
            page: 1, // Current page for pagination
            limit: 10, // Items per page
            totalPages: 1, // Total number of pages
            total: 0, // Total number of courses
            search: '', // Search query
            selectedCategory: '', // Selected category (id)
            selectedLevel: '', // Selected level
            isPaidFilter: null, // Filter for paid/free/all
            categories: [], // List of available categories
            levels: ['Beginner', 'Intermediate', 'Expert'], // Level options
            fallbackThumbnail: require('@/assets/logo.png'), // Default thumbnail if none provided
            showMembershipDialog: false, // Controls membership dialog
            subscription: {
                exists: false,
                isActive: false,
                status: '',
            },
        };
    },
    watch: {
        /**
         * Watches the 'page' property and refetches courses when it changes.
         * @param {number} newVal - The new page number.
         * @param {number} oldVal - The previous page number.
         */
        page(newVal, oldVal) {
            this.fetchCourses();
        },
        /**
         * Watches the 'limit' property and refetches courses when it changes.
         * @param {number} newVal - The new limit value.
         * @param {number} oldVal - The previous limit value.
         */
        limit(newVal, oldVal) {
            this.fetchCourses();
        }
    },
    async mounted() {
        // Set the page title and fetch initial data
        eventBus.$emit('changeTop', { title: 'Training Courses', simple: true, topLogo: false });
        await this.fetchCategories();
        await this.fetchCourses();

        if (!this.subscription.exists) {
            // Check for session_id in query params
            const sessionId = this.$route.query.session_id;
            // console.log('SessionId:', sessionId);
            if (sessionId) {
                this.$bvToast && this.$bvToast.toast('Successfully subscribed!', {
                    title: 'Subscription',
                    autoHideDelay: 5000,
                });
                this.$router.replace({ query: { ...this.$route.query, session_id: undefined } });
            }
        }

        const response = await this.checkIsSubscribed();
        if (response && response.data) {
            this.subscriptionSetter(response.data);
        }
        this.loading = false;
    },
    methods: {
        /**
         * Fetch the list of categories (specialities) from the API.
         * @returns {Promise<void>} Updates the categories array in component state.
         */
        async fetchCategories() {
            axios.get('/data/specialities')
                .then(res => {
                    // Expecting an array of {id, title}
                    this.categories = res.data;
                    // If the selectedCategory is not in the new list, reset it
                    if (this.selectedCategory && !this.categories.some(cat => cat.id == this.selectedCategory)) {
                        this.selectedCategory = '';
                    }
                })
                .catch(() => {
                    this.categories = [];
                });
        },

        /**
         * Fetch the list of courses from the API with current filters and pagination.
         * Updates courses, total, totalPages, and page in component state.
         * @returns {Promise<void>}
         */
        async fetchCourses() {
            this.loading = true;
            // Build query params
            const params = {
                page: this.page,
                limit: this.limit,
            };
            // Send category as title, not id
            if (this.selectedCategory) {
                const selectedCatObj = this.categories.find(cat => cat.id == this.selectedCategory);
                if (selectedCatObj) {
                    params.speciality = selectedCatObj.title;
                }
            }
            if (this.selectedLevel) params.level = this.selectedLevel;
            if (this.search) params.search = this.search;
            if (this.isPaidFilter !== null) params.isPaid = this.isPaidFilter;
            axios
                .get('/staff/training-courses/', { params })
                .then((res) => {
                    this.courses = res.data.data;
                    this.total = res.data.total;
                    this.totalPages = res.data.pages;
                    this.page = res.data.page;
                })
                .catch(() => {
                    this.courses = [];
                    this.total = 0;
                    this.totalPages = 1;
                })
        },

        /**
         * Check subscription/membership status for the current user.
         * @returns {Promise<Object>} Axios response containing subscription status data.
         * @throws {Error} If the request fails.
         */
        async checkIsSubscribed() {
            try {
                const response = axios.get('/subscription/status');
                return response;
            } catch (e) {
                throw e;
            }
        },

        /**
         * Update the watch time and progress status for a course in the local state.
         * @param {Object} param0 - Object containing courseId, status, and watchTime.
         * @param {string|number} param0.courseId - The ID of the course.
         * @param {string} param0.status - The progress status.
         * @param {number} param0.watchTime - The watch time in seconds.
         */
        onProgressUpdated({ courseId, status, watchTime }) {
            // Find the course and update its learningProgress.status
            const course = this.courses.find(c => c.id === courseId);
            if (course) {
                if (!course.learningProgress) {
                    course.learningProgress = {};
                }
                course.learningProgress.status = status;
                course.learningProgress.watchTime = watchTime;
            }
        },


        /**
         * Handler for search input. Resets to page 1 and fetches courses.
         */
        async onSearch() {
            this.page = 1;
            await this.fetchCourses();
            this.loading = false;
        },

        /**
         * Handler for filter dropdowns. Resets to page 1 and fetches courses.
         */
        async onFilterChange() {
            this.page = 1;
            await this.fetchCourses();
            this.loading = false;
        },

        /**
         * Set the paid/free/all filter and refetch courses.
         * @param {boolean|null} val - The filter value: true (paid), false (free), or null (all).
         */
        async setPaidFilter(val) {
            this.isPaidFilter = val;
            this.page = 1;
            await this.fetchCourses();
            this.loading = false;
        },

        /**
         * Handler for the paid/free/all filter select (mobile).
         * Converts the string value to boolean/null and sets the filter.
         */
        onPaidFilterChange(event) {
            let val = event.target.value;
            if (val === 'true') val = true;
            else if (val === 'false') val = false;
            else val = null;
            this.setPaidFilter(val);
        },

        /**
         * Go to a specific page in pagination.
         * @param {number} p - The page number to go to.
         */
        goToPage(p) {
            if (p >= 1 && p <= this.totalPages && p !== this.page) {
                this.page = p;
            }
        },

        onClickOfCourse(course) {
            if (course.isPaid && !this.subscription.exists) {
                this.showMembershipDialog = true;
                return;
            }

            this.$router.push({
                name: 'staff.training-courses.course-detail',
                params: { courseId: course.id }
            });
        },

        /**
         * Open the video player modal with the selected course's data.
         * If the course is paid and the user does not have a subscription, show the membership dialog instead.
         * @param {Object} course - The course object to open in the video player.
         */
        // openVideoPlayer(course) {
        //     if (course.isPaid && !this.subscription.exists) {
        //         this.showMembershipDialog = true;
        //         return;
        //     }
        //     this.selectedVideo = {
        //         courseId: course.id,
        //         isVideo: course.isVideoUploaded,
        //         videoUrl: course.videoUrl,
        //         title: course.title,
        //         description: course.description,
        //         thumbnail: course.thumbnailUrl || this.fallbackThumbnail,
        //         level: course.level,
        //         category: course.speciality.title,
        //         duration: course.duration,
        //         price: course.price,
        //         isPaid: course.isPaid,
        //         previousWatchedTime: course.learningProgress.watchTime
        //     };
        //     this.showVideoModal = true;
        //     this.videoModalMode = 'regular';
        // },

        /**
         * Close the video player modal and reset the selected video.
         */
        // closeVideoPlayer() {
        //     this.showVideoModal = false;
        //     this.selectedVideo = {};
        // },

        /**
         * Set the video modal display mode.
         * @param {string} mode - The display mode: 'regular', 'fullscreen', or 'mini'.
         */
        // setVideoModalMode(mode) {
        //     this.videoModalMode = mode;
        // },

        setProgressStatus(course) {
            const status = course.learningProgress && course.learningProgress.status;
            return status && status.trim() ? status : 'not started';
        },

        /**
         * Setter method to set the subscription data property
         * on the basis of response coming from the checkIsSubscribed method.
         * @param {Object} data - The subscription status data from the API.
         */
        subscriptionSetter(data) {
            this.subscription.exists = data.has_subscription ? true : false;
            this.subscription.isActive = data.active ? true : false;
            this.subscription.status = data.status ?? '';
        },

        /**
         * Listener to handle the event from the subscription modal.
         * Initiates the Stripe Checkout flow for membership.
         * @returns {Promise<void>}
         */
        async onGetMembership() {
            this.showMembershipDialog = false;
            this.$router.push({ name: 'staff.subscriptions', query: { 'redirectTo': 'training-courses' } });
        },

    },
    computed: {
        /**
         * Returns an array of course pairs for display in a two-column layout.
         * Each pair is an array of up to two course objects.
         * @returns {Array<Array<Object>>} Array of course pairs.
         */
        cardPairs() {
            const pairs = [];
            for (let i = 0; i < this.courses.length; i += 2) {
                pairs.push([this.courses[i], this.courses[i + 1]]);
            }
            return pairs;
        },
    },
};
</script>
